import { ConnectedAddToScheduleModal } from 'components/shared/ScheduledRun/Modal/AddToScheduleModal';
import { ConnectedNewScheduleModal } from 'components/shared/ScheduledRun/Modal/NewScheduleModal';
import type { IdOwnProps } from 'components/shared/ScheduledRun/type';
import { connect, type MapStateToProps } from 'react-redux';
import type { ScheduleOperation } from 'state/scheduledRuns/state';
import type { AppState } from 'state/state.model';

interface ScheduleModalStateProps {
  type?: ScheduleOperation;
  isOpen: boolean;
}
interface Props extends ScheduleModalStateProps, IdOwnProps {}
const mapStateToProps: MapStateToProps<ScheduleModalStateProps, IdOwnProps, AppState> = (
  { scheduledRun, helpCenter },
  { id },
) => ({
  type: scheduledRun.runs[id]?.type,
  isOpen: helpCenter.currentContext !== 'scheduled-run',
});
export const ConnectedScheduleModal = connect(mapStateToProps)(ScheduleModal);
export function ScheduleModal({ type, id, isOpen }: Props) {
  return isOpen && getModalByType(id, type);
}

function getModalByType(id: string, type?: ScheduleOperation) {
  switch (type) {
    case 'updateQuotes':
      return <ConnectedAddToScheduleModal id={id} />;
    case 'editSchedule':
      return <ConnectedNewScheduleModal id={id} />;
  }
  return undefined;
}
